import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { take, takeWhile } from 'rxjs/operators';
import { DienstleistungsArt } from '../../domain/model/dienstleistungsart.model';
import { DienstleistungsartService } from '../../service/dienstleistungsmodule/dienstleistungsart.service';
import { combineLatest } from 'rxjs';
import { DienstleistungsModuleBeschreibung } from '../../domain/model/dienstleistungsmodulebeschreibung.model';
import {
    SettingsDienstleistungsartenDetailComponent,
} from '../settings-dienstleistungsarten-detail/settings-dienstleistungsarten-detail.component';
import { DienstleistungsmoduleService } from '../../service/dienstleistungsmodule/dienstleistungsmodule.service';

@Component({
    selector: 'redispatch-settings-dienstleistungsarten',
    templateUrl: './settings-dienstleistungsarten-page.component.html',
    styleUrls: [
        './settings-dienstleistungsarten-page.component.scss',
    ],
    standalone: false,
})
export class SettingsDienstleistungsartenPageComponent implements OnInit, OnDestroy {

    public dienstleistungsartList = new MatTableDataSource<DienstleistungsArt>();
    public componentDestroyed = false;

    private datasourceFilter = ((data: DienstleistungsArt, filter: string) => {
        if (!filter) {
            return true;
        }
        filter = filter.toLowerCase();
        return (
            data.title.toLowerCase().indexOf(filter) !== -1 ||
            data.notes && data.notes.toLowerCase().indexOf(filter) !== -1 ||
            data.dienstleistungsmoduleBeschreibung.reduce((value, current) => {
                return value + current.title.toLowerCase();
            }, '').indexOf(filter) !== -1
        );
    });

    public westnetzSidenavService = inject(WestnetzSidenavService);
    private dienstleistungsartService = inject(DienstleistungsartService);
    private dienstleistungsmoduleService = inject(DienstleistungsmoduleService);
    private router = inject(Router);
    private changeDetectorRef = inject(ChangeDetectorRef);

    public columnsToDisplay = [
        'title',
        'dienstleistungsmoduleBeschreibung',
        'notes',
    ];

    ngOnInit() {
        this.dienstleistungsartList.filterPredicate = this.datasourceFilter;

        this.reloadData();
        this.westnetzSidenavService.closeRightnav$
            .pipe(takeWhile(() => !this.componentDestroyed))
            .subscribe(() => {
                this.reloadData();
            });
    }

    ngOnDestroy(): void {
        this.componentDestroyed = true;
    }

    private reloadData() {
        combineLatest([
            this.dienstleistungsartService.listDienstleistungsarten(),
            this.dienstleistungsmoduleService.listDienstleistungsModuleBeschreibung(),
        ])
            .pipe(take(1))
            .subscribe(([
                dlArtList,
                dlModules,
            ]) => {
                this.dienstleistungsartList.data = dlArtList.map(
                    value => {
                        value.dienstleistungsmoduleBeschreibung = SettingsDienstleistungsartenPageComponent.resolveModuleDescription(value, dlModules);
                        return value;
                    },
                );
                this.changeDetectorRef.markForCheck();
            });
    }

    private static resolveModuleDescription(
        dlArt: DienstleistungsArt,
        moduleBeschreibung: DienstleistungsModuleBeschreibung[],
    ): DienstleistungsModuleBeschreibung[] {
        return dlArt.dienstleistungsmodule.map(module => {
            return moduleBeschreibung.find(value => value.dienstleistungsmodule === module);
        });
    }

    public applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dienstleistungsartList.filter = filterValue.trim().toLowerCase();
    }

    public openDienstleistungsArt(dlArt: DienstleistungsArt) {
        this.router.navigate([],
            {
                queryParams: { dlArt: dlArt.id },
                queryParamsHandling: 'merge',
                skipLocationChange: true,
            });
        this.westnetzSidenavService.openRightnav(SettingsDienstleistungsartenDetailComponent);

    }

    public createDienstleistungsArt() {
        this.router.navigate([],
            {
                queryParams: { dlArt: '' },
                queryParamsHandling: 'merge',
                skipLocationChange: true,
            });
        this.westnetzSidenavService.openRightnav(SettingsDienstleistungsartenDetailComponent);
    }
}
